export class Message {
	readonly id: number;
	idSender: number;
	idReceiver: number;
	messageContent: string;
	createdAt: Date;

	constructor(
		option: {
			idSender?: number;
			idReceiver?: number;
			messageContent?: string;
			createdAt?: Date;
		} = {}
	) {
		this.idSender = option.idSender || null;
		this.idReceiver = option.idReceiver || null;
		this.messageContent = option.messageContent || null;
		this.createdAt = new Date();
	}
}
